export enum ContentPrefixes {
    Content = 'CONTENT',
    ChatAttachment = 'CHAT-ATTACHMENT',
    VideoThumbnail = 'VIDEO-THUMBNAIL',
    FlashcardImage = 'FLASHCARD-IMAGE',
    AiSummarySource = 'AI_SUMMARY_SOURCE',
    TutoringMockExam = 'TUTORING_MOCK_EXAM',
}
